import {
  DocumentSectionModuleType,
  DocumentVersionFieldObject,
  PublicDocumentVersionFieldObject,
} from '@client/graphql/__generated__/types';
import { useCallback, useEffect, useState } from 'react';
import { getFieldValuesForDocumentSection } from '~/services/document/utils/field';
import { DocumentSectionWithChildren } from '../../DocumentSections/types';
import { ValuesType } from '../../FormFields/types';

interface UseDocumentVersionValuesOptions {
  documentVersionFields?: Partial<
    DocumentVersionFieldObject | PublicDocumentVersionFieldObject
  >[];
  values?: ValuesType;
  offerFlowSections?: Record<
    DocumentSectionModuleType,
    DocumentSectionWithChildren | undefined
  >;
}

/**
 * TODO: If re-enabling client-side formula evaluation for prefilled values,
 * refactor to use the EvaluateFormula GraphQL query instead of the client-side
 * evaluateFormula function. The client-side version does not support LLM formulas.
 * Use useEvaluateFormulaLazyQuery instead.
 */
export const useDocumentVersionValues = (
  options: UseDocumentVersionValuesOptions
) => {
  const [values, setValues] = useState({});

  // Client-side formula evaluation disabled - needs refactoring to use GraphQL query for LLM support
  // const fieldsWithAutofill = useMemo(() => {
  //   return options.documentVersionFields?.filter(({ autofill, field }) => {
  //     return autofill?.formula || field?.autofill?.formula;
  //   });
  // }, [options.documentVersionFields]);
  //
  // const prefilledValues = useCallback(
  //   (updatedValues: ValuesType) => {
  //     return fieldsWithAutofill?.reduce(
  //       (autofillValues, { field, autofill }) => {
  //         const targetAutofill = autofill || field?.autofill;
  //         const variableSources = targetAutofill?.variableSources || [];
  //
  //         if (
  //           targetAutofill &&
  //           targetAutofill.formula &&
  //           variableSources.length === 1 &&
  //           variableSources[0] === VariableSource.FIELD &&
  //           field
  //         ) {
  //           const { output } = evaluateFormula(
  //             targetAutofill.formula,
  //             targetAutofill.formulaVariableFields,
  //             updatedValues
  //           );
  //
  //           const dataType = getVariableDataTypeForFieldType(field.fieldType);
  //
  //           if (output) {
  //             autofillValues[field.mappingKey] = convertFormulaOutput(
  //               dataType,
  //               output
  //             );
  //           }
  //         }
  //
  //         return autofillValues;
  //       },
  //       {} as ValuesType
  //     );
  //   },
  //   [fieldsWithAutofill]
  // );

  const updateValues = useCallback(
    (newValues: ValuesType, autofillValues?: ValuesType) => {
      setValues((prev) => {
        const updatedValues = { ...autofillValues, ...prev, ...newValues };

        return updatedValues;
      });
    },
    []
  );

  useEffect(() => {
    if (options.values) {
      // Make sure to overwrite any preapproval field values
      const preapprovalFieldValues = getFieldValuesForDocumentSection(
        options.offerFlowSections?.BUYER,
        options.values
      );
      // need prev value so unsaved input values arent overwritten by reloading the offer
      setValues((prev) => {
        return { ...options.values, ...prev, ...preapprovalFieldValues };
      });
    }
  }, [options.values, options.offerFlowSections]);

  return {
    values,
    updateValues,
  };
};
